module.exports = __webpack_public_path__ + "static/img/beizhengshouhu_01.551b27f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/beizhengshouhu_01.png
// module id = rtYZ
// module chunks = 1